/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export enum ProductType {
  Past = "Past",
  All = "All",
  Alternative = "Alternative",
}

export enum PriceStyle {
  RRP = "RRP",
  Discounted = "Discounted",
  Cancelled = "Cancelled",
}

export type Label = {
  type: (typeof PriceStyle)[keyof typeof PriceStyle];
  label: string;
  value: string;
  valueWithGst?: number;
  testId?: string;
  gstLabel?: string;
};
